// Components==============
import AddUserModal from 'components/UI/AddUserModal/AddUserModal';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext } from 'react';
import './AddMemberModal.module.scss';
// =========================

export default function AddMemberModal({
  setModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const translate = useTranslate();
  const { handleAddGroupMember, project } = useContext(ProjectDetailsContext);

  const message = (user: UserEntity) =>
    project?.members.find((m) => m.user_id === user.id)
      ? `  <b>(${translate('project.terms.already-in-group')})</b>`
      : user.alreadyInProject
      ? `  <b>(${translate('project.terms.already-in-project')})</b>`
      : '';

  return (
    <AddUserModal
      title={translate(
        'project.groupswork-popups.owner-image-popup.collaborate'
      )}
      description={translate(
        'project.groupswork-popups.owner-image-popup.description3'
      )}
      onSubmit={handleAddGroupMember}
      setModalIsOpen={setModalIsOpen}
      message={message}
    />
  );
}
